import { IFacility } from '../models/facility';
import { IApiService } from '../services/api_service';

export const website = (centralApi: IApiService) => ({
  getBaseData: (hostname: string) =>
    centralApi.get<IFacility>('/facility/by-site-url/' + hostname)
});
